/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Payment_Applied_To_DebtInputs */

const vi_customer_debt_payment_applied_to_debt = /** @type {(inputs: Customer_Debt_Payment_Applied_To_DebtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sẽ trừ vào nợ`)
};

/**

* @param {Customer_Debt_Payment_Applied_To_DebtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_payment_applied_to_debt = /** @type {((inputs?: Customer_Debt_Payment_Applied_To_DebtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Payment_Applied_To_DebtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_payment_applied_to_debt(inputs)
});